import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters, mapActions } from "vuex";
import { LOAD_AGENTS } from "../store/agent-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AgentsDropdown",
  props: {
    showAll: {
      type: Boolean,
      default: false
    },
    preloadAgents: {
      type: Boolean,
      default: true
    },
    selectedAgent: {
      type: String,
      default: ""
    },
    allowSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AgentStore", ["agents"])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    allIsSelected() {
      return this.computedSelectedAgent === "";
    },
    meIsSelected() {
      return this.computedSelectedAgent === this.CURRENT_USER_USERNAME;
    },
    computedDropdownDisplayText() {
      var _context, _agentInfo$displayNam;
      if (this.allIsSelected) return this.$tc("global.words.all", 1);
      if (this.meIsSelected) return this.$t("global.words.me");
      const agentInfo = _findInstanceProperty(_context = this.agentsList).call(_context, agent => agent.username === this.computedSelectedAgent);
      return (_agentInfo$displayNam = agentInfo == null ? void 0 : agentInfo.displayName) != null ? _agentInfo$displayNam : "";
    },
    agentsList() {
      var _context2;
      const currentUser = {
        displayName: this.$t("global.words.me"),
        username: this.CURRENT_USER_USERNAME
      };
      const showAllOption = {
        displayName: this.$tc("global.words.all", 1),
        username: ""
      };
      const extraOptions = [currentUser];
      if (this.showAll) extraOptions.unshift(showAllOption);
      const allAgents = _reduceInstanceProperty(_context2 = this.agents).call(_context2, (acc, agent) => {
        if (agent.username !== this.CURRENT_USER_USERNAME) {
          acc.push({
            displayName: `${agent.givenName} ${agent.familyName}`,
            username: agent.username
          });
        }
        return acc;
      }, []);
      return [...extraOptions, ...allAgents];
    },
    agentsListFiltered() {
      var _context3;
      if (!this.allowSearch || !this.search) return this.agentsList;
      return _filterInstanceProperty(_context3 = this.agentsList).call(_context3, ({
        displayName
      }) => {
        var _context4, _this$search;
        return displayName == null ? void 0 : _includesInstanceProperty(_context4 = displayName.toLowerCase()).call(_context4, (_this$search = this.search) == null ? void 0 : _this$search.toLowerCase());
      });
    },
    computedSelectedAgent: {
      set(value) {
        this.$emit("update:selectedAgent", value);
      },
      get() {
        return this.selectedAgent;
      }
    }
  }),
  watch: {
    computedSelectedAgent: {
      immediate: true,
      handler() {
        this.search = "";
      }
    }
  },
  async mounted() {
    if (this.preloadAgents && !this.agents.length) await this.LOAD_AGENTS();
    this.search = "";
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AgentStore", [LOAD_AGENTS])), {}, {
    handleClick(agent) {
      this.computedSelectedAgent = agent.username;
    }
  })
});